// // searchService.js
// import { collection, getDocs, query } from 'firebase/firestore';

// export const searchDatabase = async (db, searchQuery) => {
//   if (!searchQuery.trim()) return [];
  
//   const searchTerms = searchQuery.toLowerCase().trim().split(' ');
//   const results = [];

//   // Helper function to check if text matches search terms
//   const matchesSearch = (text) => {
//     if (!text) return false;
//     text = text.toLowerCase();
//     return searchTerms.some(term => text.includes(term));
//   };

//   // Helper function to highlight matched terms
//   const highlightText = (text) => {
//     if (!text) return '';
//     let highlighted = text;
//     searchTerms.forEach(term => {
//       const regex = new RegExp(`(${term})`, 'gi');
//       highlighted = highlighted.replace(regex, '<mark>$1</mark>');
//     });
//     return highlighted;
//   };

//   try {
//     // Search projects
//     const projectsSnapshot = await getDocs(collection(db, 'projects'));
//     projectsSnapshot.forEach(doc => {
//       const data = doc.data();
//       if (
//         matchesSearch(data.title) ||
//         matchesSearch(data.description) ||
//         matchesSearch(data.content)
//       ) {
//         results.push({
//           type: 'project',
//           id: doc.id,
//           title: highlightText(data.title),
//           description: highlightText(data.description),
//           content: highlightText(data.content),
//           coverImage: data.coverImage,
//           slug: data.slug,
//           originalData: data
//         });
//       }
//     });

//     // Search news
//     const newsSnapshot = await getDocs(collection(db, 'news'));
//     newsSnapshot.forEach(doc => {
//       const data = doc.data();
//       if (
//         matchesSearch(data.title) ||
//         matchesSearch(data.description) ||
//         matchesSearch(data.content)
//       ) {
//         results.push({
//           type: 'news',
//           id: doc.id,
//           title: highlightText(data.title),
//           description: highlightText(data.description),
//           content: highlightText(data.content),
//           category: data.category,
//           originalData: data
//         });
//       }
//     });

//     // Search events
//     const eventsSnapshot = await getDocs(collection(db, 'events'));
//     eventsSnapshot.forEach(doc => {
//       const data = doc.data();
//       if (
//         matchesSearch(data.title) ||
//         matchesSearch(data.description) ||
//         matchesSearch(data.location)
//       ) {
//         results.push({
//           type: 'event',
//           id: doc.id,
//           title: highlightText(data.title),
//           description: highlightText(data.description),
//           location: highlightText(data.location),
//           startDate: data.startDate,
//           endDate: data.endDate,
//           originalData: data
//         });
//       }
//     });

//     return results;
//   } catch (error) {
//     console.error('Search error:', error);
//     throw error;
//   }
// };












// import { collection, getDocs, query, where } from 'firebase/firestore';

// export const searchDatabase = async (db, searchQuery) => {
//   if (!searchQuery.trim()) return [];
  
//   const searchTerms = searchQuery.toLowerCase().trim().split(' ');
//   const results = [];

//   // Helper function to check if text matches search terms
//   const matchesSearch = (text) => {
//     if (!text) return false;
//     text = text.toLowerCase();
//     return searchTerms.some(term => text.includes(term));
//   };

//   // Helper function to highlight matched terms
//   const highlightText = (text) => {
//     if (!text) return '';
//     let highlighted = text;
//     searchTerms.forEach(term => {
//       const regex = new RegExp(`(${term})`, 'gi');
//       highlighted = highlighted.replace(regex, '<mark>$1</mark>');
//     });
//     return highlighted;
//   };

//   // Helper function to search a collection
//   const searchCollection = async (collectionName, fields) => {
//     const snapshot = await getDocs(collection(db, collectionName));
//     snapshot.forEach(doc => {
//       const data = doc.data();
      
//       // Check all specified fields and any additional fields in the document
//       const matchFound = Object.keys(data).some(field => {
//         const value = data[field];
//         // Check if the value is a string and contains the search term
//         return typeof value === 'string' && matchesSearch(value);
//       });

//       if (matchFound) {
//         results.push({
//           type: collectionName === 'projects' ? 'project' : 
//                 collectionName === 'news' ? 'news' : 'event',
//           id: doc.id,
//           title: highlightText(data.title),
//           description: highlightText(data.description),
//           content: highlightText(data.content),
//           coverImage: data.coverImage,
//           slug: data.slug,
//           category: data.category,
//           startDate: data.startDate,
//           endDate: data.endDate,
//           location: data.location ? highlightText(data.location) : null,
//           originalData: data
//         });
//       }
//     });
//   };

//   try {
//     // Search all collections
//     await Promise.all([
//       searchCollection('projects', ['title', 'description', 'content']),
//       searchCollection('news', ['title', 'description', 'content']),
//       searchCollection('events', ['title', 'description', 'location'])
//     ]);

//     return results;
//   } catch (error) {
//     console.error('Search error:', error);
//     throw error;
//   }
// };








// import { collection, getDocs } from 'firebase/firestore';

// export const searchDatabase = async (db, searchQuery) => {
//   if (!searchQuery.trim()) return [];
  
//   const searchTerms = searchQuery.toLowerCase().trim().split(' ');
//   const results = [];

//   // Helper function to check if text matches search terms
//   const matchesSearch = (text) => {
//     if (!text) return false;
//     if (typeof text !== 'string') return false;
//     text = text.toLowerCase();
//     return searchTerms.some(term => text.includes(term));
//   };

//   // Helper function to highlight matched terms
//   const highlightText = (text) => {
//     if (!text || typeof text !== 'string') return '';
//     let highlighted = text;
//     searchTerms.forEach(term => {
//       const regex = new RegExp(`(${term})`, 'gi');
//       highlighted = highlighted.replace(regex, '<mark>$1</mark>');
//     });
//     return highlighted;
//   };

//   // Helper function to search nested objects and arrays
//   const searchNestedFields = (obj) => {
//     if (!obj) return false;
    
//     // Handle arrays
//     if (Array.isArray(obj)) {
//       return obj.some(item => searchNestedFields(item));
//     }
    
//     // Handle objects
//     if (typeof obj === 'object') {
//       return Object.values(obj).some(value => searchNestedFields(value));
//     }
    
//     // Handle primitive values
//     return typeof obj === 'string' && matchesSearch(obj);
//   };

//   // Helper function to search a collection
//   const searchCollection = async (collectionName) => {
//     const snapshot = await getDocs(collection(db, collectionName));
    
//     snapshot.forEach(doc => {
//       const data = doc.data();
//       let matchFound = false;
      
//       // Search in primary fields
//       const primaryFields = [
//         'title',
//         'subtitle',
//         'description',
//         'location',
//         'category'
//       ];
      
//       // Check primary fields
//       matchFound = primaryFields.some(field => matchesSearch(data[field]));
      
//       // Check sections content if exists
//       if (data.sections && Array.isArray(data.sections)) {
//         matchFound = matchFound || data.sections.some(section => 
//           searchNestedFields(section)
//         );
//       }
      
//       // Check related projects if exists
//       if (data.relatedProjects && Array.isArray(data.relatedProjects)) {
//         matchFound = matchFound || data.relatedProjects.some(project => 
//           searchNestedFields(project)
//         );
//       }
      
//       // Check coverMedia if exists
//       if (data.coverMedia && typeof data.coverMedia === 'object') {
//         matchFound = matchFound || searchNestedFields(data.coverMedia);
//       }

//       if (matchFound) {
//         // Determine the type based on collection name
//         const type = collectionName === 'team-members' ? 'team' : 
//                     collectionName === 'news' ? 'news' : 'project';

//         results.push({
//           type,
//           id: doc.id,
//           title: highlightText(data.title),
//           subtitle: data.subtitle ? highlightText(data.subtitle) : null,
//           description: data.description ? highlightText(data.description) : null,
//           location: data.location ? highlightText(data.location) : null,
//           category: data.category,
//           coverImage: data.coverImage,
//           featureImage: data.featureImage,
//           slug: data.slug,
//           coverMedia: data.coverMedia,
//           createdAt: data.createdAt,
//           originalData: data
//         });
//       }
//     });
//   };

//   try {
//     // Search all collections concurrently
//     await Promise.all([
//       searchCollection('projects'),
//       searchCollection('news'),
//       searchCollection('team-members')
//     ]);

//     // Sort results by relevance (title matches first, then description matches)
//     results.sort((a, b) => {
//       const aTitle = a.title?.toLowerCase() || '';
//       const bTitle = b.title?.toLowerCase() || '';
//       const aDesc = a.description?.toLowerCase() || '';
//       const bDesc = b.description?.toLowerCase() || '';
      
//       // Check if search terms appear in title
//       const aTitleMatch = searchTerms.some(term => aTitle.includes(term));
//       const bTitleMatch = searchTerms.some(term => bTitle.includes(term));
      
//       if (aTitleMatch && !bTitleMatch) return -1;
//       if (!aTitleMatch && bTitleMatch) return 1;
      
//       // If both or neither have title matches, check description
//       const aDescMatch = searchTerms.some(term => aDesc.includes(term));
//       const bDescMatch = searchTerms.some(term => bDesc.includes(term));
      
//       if (aDescMatch && !bDescMatch) return -1;
//       if (!aDescMatch && bDescMatch) return 1;
      
//       return 0;
//     });

//     return results;
//   } catch (error) {
//     console.error('Search error:', error);
//     throw error;
//   }
// };







import { collection, getDocs } from 'firebase/firestore';
import { debounce } from 'lodash';

export const searchDatabase = async (db, searchQuery, limit = 5) => {
  if (!searchQuery.trim()) return [];
  
  const searchTerms = searchQuery.toLowerCase().trim().split(' ');
  const results = [];

  // Helper function to check if text matches search terms
  const matchesSearch = (text) => {
    if (!text) return false;
    if (typeof text !== 'string') return false;
    text = text.toLowerCase();
    return searchTerms.some(term => text.includes(term));
  };

  // Helper function to highlight matched terms
  const highlightText = (text) => {
    if (!text || typeof text !== 'string') return '';
    let highlighted = text;
    searchTerms.forEach(term => {
      const regex = new RegExp(`(${term})`, 'gi');
      highlighted = highlighted.replace(regex, '<mark>$1</mark>');
    });
    return highlighted;
  };

  // Helper function to search nested objects and arrays
  const searchNestedFields = (obj) => {
    if (!obj) return false;
    
    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.some(item => searchNestedFields(item));
    }
    
    // Handle objects
    if (typeof obj === 'object') {
      return Object.values(obj).some(value => searchNestedFields(value));
    }
    
    // Handle primitive values
    return typeof obj === 'string' && matchesSearch(obj);
  };

  // Helper function to search a collection
  const searchCollection = async (collectionName) => {
    const snapshot = await getDocs(collection(db, collectionName));
    
    snapshot.forEach(doc => {
      if (results.length >= limit) return; // Stop if limit is reached
      
      const data = doc.data();
      let matchFound = false;
      
      // Search in primary fields
      const primaryFields = ['title', 'subtitle', 'description', 'location', 'category'];
      
      matchFound = primaryFields.some(field => matchesSearch(data[field]));
      
      // Check sections content if exists
      if (data.sections && Array.isArray(data.sections)) {
        matchFound = matchFound || data.sections.some(section => searchNestedFields(section));
      }
      
      // Check related projects if exists
      if (data.relatedProjects && Array.isArray(data.relatedProjects)) {
        matchFound = matchFound || data.relatedProjects.some(project => searchNestedFields(project));
      }
      
      // Check coverMedia if exists
      if (data.coverMedia && typeof data.coverMedia === 'object') {
        matchFound = matchFound || searchNestedFields(data.coverMedia);
      }

      if (matchFound) {
        // Determine the type based on collection name
        const type = collectionName === 'team-members' ? 'team' : 
                    collectionName === 'news' ? 'news' : 'project';

        results.push({
          type,
          id: doc.id,
          title: highlightText(data.title),
          subtitle: data.subtitle ? highlightText(data.subtitle) : null,
          description: data.description ? highlightText(data.description) : null,
          location: data.location ? highlightText(data.location) : null,
          category: data.category,
          coverImage: data.coverImage,
          featureImage: data.featureImage,
          slug: data.slug,
          coverMedia: data.coverMedia,
          createdAt: data.createdAt,
          originalData: data
        });
      }
    });
  };

  try {
    // Search all collections concurrently
    await Promise.all([
      searchCollection('projects'),
      searchCollection('news'),
      searchCollection('team-members')
    ]);

    // Sort results by relevance (title matches first, then description matches)
    results.sort((a, b) => {
      const aTitle = a.title?.toLowerCase() || '';
      const bTitle = b.title?.toLowerCase() || '';
      const aDesc = a.description?.toLowerCase() || '';
      const bDesc = b.description?.toLowerCase() || '';
      
      // Check if search terms appear in title
      const aTitleMatch = searchTerms.some(term => aTitle.includes(term));
      const bTitleMatch = searchTerms.some(term => bTitle.includes(term));
      
      if (aTitleMatch && !bTitleMatch) return -1;
      if (!aTitleMatch && bTitleMatch) return 1;
      
      // If both or neither have title matches, check description
      const aDescMatch = searchTerms.some(term => aDesc.includes(term));
      const bDescMatch = searchTerms.some(term => bDesc.includes(term));
      
      if (aDescMatch && !bDescMatch) return -1;
      if (!aDescMatch && bDescMatch) return 1;
      
      return 0;
    });

    return results;
  } catch (error) {
    console.error('Search error:', error);
    throw error;
  }
};
